import { ConfigListEntry } from '../shared/app-config.model';

export function parseAllowedClientConfigKeysFromUser(user: any): string[] {
	if (Array.isArray(user?.allowedClientConfigs) && user.allowedClientConfigs.length) {
		return user.allowedClientConfigs.map((x: unknown) => String(x)).filter(Boolean);
	}
	const raw = user?.allowed_client_configs;
	if (raw == null || raw === '') {
		return [];
	}
	if (Array.isArray(raw)) {
		return raw.map(String).filter(Boolean);
	}
	if (typeof raw === 'string') {
		try {
			const arr = JSON.parse(raw);
			return Array.isArray(arr) ? arr.map(String).filter(Boolean) : [];
		} catch {
			return [];
		}
	}
	return [];
}

/** Include every config entry that shares a companyKey with any listed key (e.g. km + kmproca). */
export function expandConfigKeysByCompanyKey(keys: string[], fullList: ConfigListEntry[]): string[] {
	const k = keys.map((x) => String(x));
	const scope = new Set<string>();
	for (const e of fullList) {
		if (e.config && k.includes(e.config) && e.companyKey) {
			scope.add(e.companyKey);
		}
	}
	if (scope.size === 0) {
		return [...k];
	}
	const out = new Set(k);
	for (const e of fullList) {
		if (e.companyKey && scope.has(e.companyKey) && e.config) {
			out.add(e.config);
		}
	}
	return Array.from(out);
}
